module.exports = __webpack_public_path__ + "static/media/img_dance13.59ff68b5.png";